import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import DealsCard from './DealsCard';
import { useHealthyDealsDataContext } from '../HealthyDealsDataContextProvider/HealthyDealsData.context';
import { cardsPerPage } from '../../utils/miscConstants';

const DealsGrid = ({
	deals = {},
	loading = false,
	isRecommendedGrid = false,
	recommendedForDealName = null,
}) => {
	const { redirectToResourceLibrary } = useHealthyDealsDataContext();
	const setCardLinkPath = useCallback((type, id) => {
		if (type === 'resourcelibrary') return redirectToResourceLibrary;
		if (isRecommendedGrid) return `../${type}/${id}`;
		return `${type}/${id}`;
	}, []);
	return (
		<Grid container spacing={2}>
			{(loading ? Array.from(new Array(cardsPerPage)) : deals)?.map(
				(deal, index) =>
					((deal?.dealType === 'resourcelibrary' &&
						redirectToResourceLibrary) ||
						deal?.dealType !== 'resourcelibrary') && (
						<Grid
							item
							xs={12}
							sm={6}
							md={4}
							lg={isRecommendedGrid ? 3 : 4}
							key={loading ? index : deal?.id}
						>
							{loading ? (
								<DealsCard loading />
							) : (
								<DealsCard
									title={deal?.cardTitle}
									description={deal?.dealDescription}
									image={deal?.dealImage}
									chipLabel={deal?.dealDiscount || ''}
									cardLink={setCardLinkPath(deal?.dealType, deal?.id)}
									discountBadgeType={deal?.discountBadgeType}
									eventName={
										isRecommendedGrid
											? `recommendedClick_${deal?.dealType}_${deal?.cardTitle}`
											: `tileClick_${deal?.dealType}_${deal?.cardTitle}`
									}
									eventData={
										isRecommendedGrid
											? {
													detailPage: recommendedForDealName,
												}
											: null
									}
								/>
							)}
						</Grid>
					),
			)}
		</Grid>
	);
};

DealsGrid.propTypes = {
	deals: PropTypes.array,
	loading: PropTypes.bool,
	isRecommendedGrid: PropTypes.bool,
	recommendedForDealName: PropTypes.string,
};

export default DealsGrid;
